import { render, staticRenderFns } from "./Importance.vue?vue&type=template&id=5d8805e4&scoped=true"
import script from "./Importance.vue?vue&type=script&lang=js"
export * from "./Importance.vue?vue&type=script&lang=js"
import style0 from "./Importance.vue?vue&type=style&index=0&id=5d8805e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8805e4",
  null
  
)

export default component.exports